import queryString from 'query-string';

export const DESIGNER_MODE = 'designer';
export const INTERNAL_DESIGNER_MODE = 'internal_designer';
export const USER_MODE = 'user';

/**
 * 获取地址参数对象
 */
export const getQuery = () => {
    return queryString.parse(window.location.search) as { [key: string]: string };
};

/**
 * 获取当前用户的角色
 *
 * - 非本地环境下，根据当前域名判断
 * - 本地环境下，根据 `query` 中的 `mode` 参数值判断
 *
 * @returns `{'user' | 'designer' | 'internal_designer'}` 用户/设计师/内部设计师
 */
export const getCurMode = () => {
    let mode = '';
    const params = getQuery();

    // 本地开发环境
    const isDev = window.location.hostname.includes('localhost');
    if (isDev) {
        mode = params.mode as string;
        return mode;
    }

    // 非本地开发环境
    const matches = window.location.hostname.match(/^(.+)\.meitu.com$/);
    const prefix = (matches && matches[1]) || '';

    if (/.*mcp$/.test(prefix)) {
        mode = DESIGNER_MODE;

        // NOTE 等内部设计师角色跳转迁移到新的域名后，再修复成根据域名来判断mode
        if (params.mode === INTERNAL_DESIGNER_MODE) mode = INTERNAL_DESIGNER_MODE;
    } else if (/.*pc$/.test(prefix)) {
        mode = USER_MODE;
    }

    return mode;
};

/**
 * 是否是设计师编辑器模式
 * @returns `true`/`false`
 */
export const isDesignerMode = () => {
    return getCurMode() === DESIGNER_MODE;
};

/**
 * 是否是内部设计师编辑器模式
 * @returns `true`/`false`
 */
export const isInternalDesignerMode = () => {
    return getCurMode() === INTERNAL_DESIGNER_MODE;
};

/**
 * 是否是花字生成模式
 * @returns `true`/`false`
 */
export const checkIsInArtTextGeneratorMode = () => {
    return isInternalDesignerMode() && getQuery().type === 'textArt';
};
